import React from 'react'

import { Checkbox, Col, Form, Typography } from 'antd';

export default function PersonalDataFiltersActiveUsers({ form, labelValue }) {
   
   const label = labelValue || "Attivazione Utente";

  return (
      <Col span={24}>
         <Form.Item
           name={"active_users_only"}
            valuePropName="checked"
         >
            <Checkbox><Typography className='fs-16'>Seleziona solo utenti Attivi</Typography></Checkbox>
         </Form.Item>
         <Form.Item
            name={"inactive_users_only"}
            valuePropName="checked"
         >
            <Checkbox><Typography className='fs-16'>Seleziona solo utenti Non Attivi</Typography></Checkbox>
         </Form.Item>
      </Col>
  )
}
